'use strict';

export default class GoogleMap {
    constructor (options) {
        const GOOGLE_SCRIPT_FLAG_CLASS = 'is-google-script-loaded';

        let $body = $('body'),
            isLoadedScripts = () => $body.hasClass(GOOGLE_SCRIPT_FLAG_CLASS);

        if (
            !$(`${options.mapSelector || '#mapCanvas'}`).length
        ) {
            return;
        }

        this.$gMarker = [];
        this.$mapHld = $(`${options.mapSelector || '#mapCanvas'}`);
        this.gLat = options.lat || 0;
        this.gLng = options.lng || 0;
        this.gMarkerSettings = options.marker || {};
        this.callback = options.callback;

        if (!isLoadedScripts()) {
            $.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyC5GQHWxVG1zI1RfQtZdv4_Iriqt9BGCXQ', () => {
                $body.addClass(GOOGLE_SCRIPT_FLAG_CLASS);

                this.loadMap();
            });
        } else {
            this.loadMap();
        }
    }

    getOptions () {
        let lat = this.gLat,
            lng = this.gLng;

        return {
            center: new google.maps.LatLng(lat, lng),
            zoom: 8,
            scrollwheel: false,
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.DEFAULT,
                position: google.maps.ControlPosition.TOP_LEFT
            },
            panControl: false,
            panControlOptions: {
                position: google.maps.ControlPosition.TOP_LEFT
            },
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL,
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            scaleControl: false,
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            }
        };
    }

    getMarkerOptions (options) {
        let iconColor = '#666';
        if (typeof options.marker !== 'undefined' && typeof options.marker.icon.fillColor !=='undefined') {
            iconColor = options.marker.icon.fillColor;
        }
        let draggable = false;
        if (typeof options.marker !== 'undefined' && options.marker.draggable === true) {
            draggable = true;
        }
        return Object.assign({
            position: new google.maps.LatLng(options.lat, options.lng),
            map: this.$gMap,
            draggable:draggable,
            icon: {
                path: 'M25,0C14.65,0,6.25,8.4,6.25,18.75 C6.25,29.1,25,50,25,50s18.75-20.9,18.75-31.25C43.75,8.4,35.35,0,25,0z',
                fillColor: iconColor,
                fillOpacity: 1,
                strokeColor: iconColor,
                strokeWeight: 0,
                scale: 0.575,
                size: new google.maps.Size(38, 50),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(19, 50),
                labelOrigin: new google.maps.Point(25, 20)
            }
        }, this.gMarkerSettings, options);
    }

    loadMap () {
        let options = this.getOptions(),
            directionsDisplay = new google.maps.DirectionsRenderer(),
            $map = this.$mapHld;

        this.$gMap = new google.maps.Map($map.get(0), options);

        this.infoWindow =  new google.maps.InfoWindow();

        if (this.gLat && this.gLng) {
            this.setMarker({lat: this.gLat, lng: this.gLng});
        }

        directionsDisplay.setMap(this.$gMap);

        if (typeof this.callback === 'function') {
            this.callback();
        }

        $(window).on('gMap:refreshMap', () => {
            google.maps.event.trigger(this.$gMap, 'resize');
        });

        $(window).trigger('gMap:loaded');
    }

    changeMarkerPosition (params = {}) {
        let {idx, lat, lng, followFocus} = params;

        if (
            typeof !lat === 'undefined' ||
            typeof !lng === 'undefined' ||
            typeof idx === 'undefined' ||
            !this.$gMarker[idx]
        ) {
            return;
        }

        let gLatLng = new google.maps.LatLng(lat, lng);

        this.$gMarker[idx].setPosition(gLatLng);

        if (followFocus) {
            this.$gMap.setCenter(gLatLng);
        }
    }

    setMarker (options = {}) {
        let marker = new google.maps.Marker(this.getMarkerOptions(options));
        var infoWindow = this.infoWindow;
        if (options.infoWindow) {
            marker.addListener('click', function() {
                infoWindow.setOptions(options.infoWindow);
                infoWindow.open(this.$gMap, marker);
            });
        }
        return this.$gMarker.push(marker);
    }
}
